module.exports = __webpack_public_path__ + "img/logo-kosher.com@2x.f44d1910.png";